import { render } from "./StoreSetup.vue?vue&type=template&id=2c00b779&scoped=true"
import script from "./StoreSetup.vue?vue&type=script&lang=js"
export * from "./StoreSetup.vue?vue&type=script&lang=js"

import "./StoreSetup.vue?vue&type=style&index=0&id=2c00b779&lang=css"
import "./StoreSetup.vue?vue&type=style&index=1&id=2c00b779&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c00b779"]])

export default __exports__